/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const linkTelegramResponseDataSchema = z.object({
  linked: z.boolean(),
  telegramUsername: z.string().nullable(),
});

export type ILinkTelegramResponseData = z.infer<typeof linkTelegramResponseDataSchema>;

export const linkTelegramResponseSchema = createApiResponseSchema(
  linkTelegramResponseDataSchema,
) as z.ZodSchema<IAPI<ILinkTelegramResponseData>>;

export type ILinkTelegramResponse = IAPI<ILinkTelegramResponseData>;
